var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "search_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.943 15.943a1 1 0 011.414 0l4.35 4.35a1 1 0 01-1.414 1.414l-4.35-4.35a1 1 0 010-1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExIDRDNy4xMzQwMSA0IDQgNy4xMzQwMSA0IDExQzQgMTQuODY2IDcuMTM0MDEgMTggMTEgMThDMTQuODY2IDE4IDE4IDE0Ljg2NiAxOCAxMUMxOCA3LjEzNDAxIDE0Ljg2NiA0IDExIDRaTTIgMTFDMiA2LjAyOTQ0IDYuMDI5NDQgMiAxMSAyQzE1Ljk3MDYgMiAyMCA2LjAyOTQ0IDIwIDExQzIwIDE1Ljk3MDYgMTUuOTcwNiAyMCAxMSAyMEM2LjAyOTQ0IDIwIDIgMTUuOTcwNiAyIDExWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45NDI5IDE1Ljk0MjlDMTYuMzMzNCAxNS41NTI0IDE2Ljk2NjYgMTUuNTUyNCAxNy4zNTcxIDE1Ljk0MjlMMjEuNzA3MSAyMC4yOTI5QzIyLjA5NzYgMjAuNjgzNCAyMi4wOTc2IDIxLjMxNjYgMjEuNzA3MSAyMS43MDcxQzIxLjMxNjYgMjIuMDk3NiAyMC42ODM0IDIyLjA5NzYgMjAuMjkyOSAyMS43MDcxTDE1Ljk0MjkgMTcuMzU3MUMxNS41NTI0IDE2Ljk2NjYgMTUuNTUyNCAxNi4zMzM0IDE1Ljk0MjkgMTUuOTQyOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgSearch as ReactComponent };